import { render, staticRenderFns } from "./textEllipsis.vue?vue&type=template&id=66c1663c&"
import script from "./textEllipsis.vue?vue&type=script&lang=js&"
export * from "./textEllipsis.vue?vue&type=script&lang=js&"
import style0 from "./textEllipsis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports